/**
 * Alaska: App.js (PWA)
 * Data: Editor
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.data("Editor", () => ({
        editor: false,

        toggle_editor() {
            this.editor = !this.editor;
            Debug.log("Editor mode:", this.editor);
        }
    }));
});